import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { IonicPage, NavParams, ActionSheet, ActionSheetController, Config, NavController, ToastController, PopoverController, AlertController } from 'ionic-angular';

import { ParkbewilligungenData, PbKategorieActions, PbKategorieTyp } from '../parkbewilligungen-data';
import { PbkategorienEditPage } from './pbkategorien-edit/pbkategorien-edit';
import { ParkbewilligungenListPage } from '../parkbewilligungen-list'
import { UserData } from '../../../providers/user-data';
import { MandantenData } from '../../../providers/mandanten-data';
import { PbKategorieactionsPage } from '../pbkategorieactions/pbkategorieactions';
import { CommonData } from '../../../providers/common-data';
import { Storage } from '@ionic/storage';
import { localeDe } from '../../../providers/aggridlocale.de'
import { AgGridAngular } from 'ag-grid-angular';
import { AllModules, Module } from '@ag-grid-enterprise/all-modules';
/**
 * Generated class for the PbkategorienPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pbkategorien',
  templateUrl: 'pbkategorien.html',
})
export class PbkategorienPage {
  @ViewChild('pbKategorieGrid') agGrid: AgGridAngular;
  rowDataKategorie:any;
  columnDefsKategorie:any;
  gridOptionsKategorie:any;
  searchQuery: string;
  bFilterActive: boolean;

  modules: Module[] = AllModules;
  public PbKategorieTyp = PbKategorieTyp;

  constructor(
    public navCtrl: NavController
    , public navParams: NavParams
    , public pbData: ParkbewilligungenData
    , public userData: UserData
    , public mData: MandantenData
    , public popoverCtrl: PopoverController
    , public toastCtrl: ToastController
    , public common: CommonData
    , public storage: Storage
    , private alertCtrl: AlertController

  ) {
    this.bFilterActive = false;
    if(this.userData.usergroup_id == 1){
      this.columnDefsKategorie = [
        {
          headerName: 'Id', field: 'id' , filter: "agNumberColumnFilter", resizable: true , width:70 
        }
        ,{
          headerName: 'Mandat', field: 'mandate_id' , valueGetter: this.mandateNameValueGetter.bind(this), resizable: true , width:120, floatingFilter: true
        }

      ];      
      
    }
    else{
      this.columnDefsKategorie = [
        {
          headerName: 'Id', field: 'id' , filter: "agNumberColumnFilter", resizable: true , width:70 
        }

      ];      
    }
    
    this.columnDefsKategorie.push({headerName: 'Name', field: 'name', resizable: true, width:340 });
    this.columnDefsKategorie.push({headerName: 'Preis', type: 'numericColumn', field: 'preis', filter: "agNumberColumnFilter", resizable: true, width:70 });
    this.columnDefsKategorie.push({headerName: 'bewilligungspflichtig', field: 'bewilligungspflichtig', resizable: true, width:120, valueGetter: this.bewilligungspflichtigTextValueGetter.bind(this)  });
    this.columnDefsKategorie.push({headerName: 'Öffentlich', field: 'sichtbar', resizable: true, width:100, valueGetter: this.sichtbarTextValueGetter.bind(this)   });
    this.columnDefsKategorie.push({headerName: '24/7', field: 'defaultvalid', resizable: true, width:100 , valueGetter: this.defaultvalidTextValueGetter.bind(this)  });
    this.columnDefsKategorie.push({headerName: 'Typ', field: 'bestelltyp', resizable: true, width:100, valueGetter: this.bestelltypTextValueGetter.bind(this)   });
    this.columnDefsKategorie.push({headerName: 'Dauer', field: 'dauer', resizable: true, width:100, filter: "agNumberColumnFilter"  });
    this.columnDefsKategorie.push({headerName: 'Startdatum', field: 'datum_von', resizable: true, width:100 , valueGetter: this.startDatumTextValueGetter.bind(this)});
    this.columnDefsKategorie.push({headerName: 'Archiviert', field: 'archiviert', resizable: true, width:120 , valueGetter: this.archiviertTextValueGetter.bind(this)  });
    this.columnDefsKategorie.push({headerName: 'Erzeugt', field: 'created', resizable: true, width:120,  valueFormatter: this.dateFormatter.bind(this),  });
    
    this.gridOptionsKategorie = {         
      localeTextFunc: (key: string, defaultValue: string) =>  localeDe[key] || defaultValue,       
      isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
      doesExternalFilterPass: this.doesExternalFilterPass.bind(this),
      onGridReady: this.gridReady.bind(this),
      onFilterChanged: this.filterChanged.bind(this),
      floatingFilter: true,
      
      defaultColDef : {
        filter:true,
        sortable: true
      }
    }

  }
  dateFormatter(params) {
    
    return params.value;
    //-- wird aktuell nicht verwendet wegen sortierung
    /* 
    var dateAsString = params.value;
    console.log(params);
   
    var dateParts = dateAsString.split('-');
    return `${dateParts[0]} - ${dateParts[1]} - ${dateParts[2]}`;
    */
   
  }
  gridReady(event){
    
    //this.loadFilters();
  }

  filterChanged(event){
    /*
    var model = this.agGrid.gridOptions.api.getFilterModel();
    this.storage.set("pbkatfilter", model);        

    if(Object.keys(model).length !== 0){
      this.bFilterActive = true;
    }
    else{
      this.bFilterActive = false;
    }
    */
  }

  firstDataRendered(event){
    this.defaultFilter();
  }
  defaultFilter(){


    var filterComponent = this.agGrid.api.getFilterInstance('archiviert');
    //console.log(statusFilterComponent);
    var model = {
        type: 'set',
        values: ['nein']
    };

    filterComponent.setModel(model);
    this.agGrid.api.onFilterChanged();
  }
  ionViewWillEnter() {
    
    this.loaddata();
  }  

  async loadFilters(){
    /*
    let pbkatfilter = await this.storage.get("pbkatfilter");
    if(!pbkatfilter){
      pbkatfilter = {
        archiviert: {
          filterType: 'text',
          type: 'equals',
          filter: 'nein',
        }
      };
    }
    this.agGrid.api.setFilterModel(pbkatfilter);     
    var model = this.agGrid.api.getFilterModel();
    */
  }

  ionViewDidEnter(){
    
  }
  bewilligungspflichtigTextValueGetter = function (params){
    return this.common.boolToText(params.data.bewilligungspflichtig);
  }
  defaultvalidTextValueGetter = function (params){
    return this.common.boolToText(params.data.defaultvalid);
  }
  archiviertTextValueGetter = function (params){
    return this.common.boolToText(params.data.archiviert);
  }
  sichtbarTextValueGetter = function (params){
    return this.common.boolToText(params.data.sichtbar);
  }

  
  startDatumTextValueGetter = function (params){
    if(PbKategorieTyp.FixerZeitraum != params.data.bestelltyp){
      return "";
    }
    return params.data.datum_von;
  }  
  bestelltypTextValueGetter = function (params){
    if(PbKategorieTyp.FixeDauer == params.data.bestelltyp){
      return "Fixe Dauer";
    }
    else if(PbKategorieTyp.FixerZeitraum == params.data.bestelltyp){
      return "Fixer Zeitraum";
    }
    else if(PbKategorieTyp.Permanent == params.data.bestelltyp){
      return "permanent";
    }
    else{
      return "";
    }

    
  }

  
  


  mandateNameValueGetter = function (params) {
    if(this.mData){
      let m = this.mData.mandateby(params.data.mandate_id);
      if(m){
        return m.mandat;
      }
      else{
        return "";
      }  
    }
    else{
      return params.data.mandate_id;
    }    
  };



  loaddata(){
    this.pbData.loadcategories().then(res => {      
      if(!this.rowDataKategorie || this.rowDataKategorie.lenght==0){
        this.rowDataKategorie = this.pbData.pbcategories;
      }
      else{
        //-- Neue Eitnräge hinzufügen ------
        var transactionobject = {add:[], update:[]};
        for(let i=0; i<this.pbData.added_pbkategorie_ids.length; i++){
          let newData = this.pbData.pbcategories.find(x => x.id === this.pbData.added_pbkategorie_ids[i]);        
          if(newData){
            transactionobject.add.push(newData);
          }    
        }
        this.pbData.added_pbkategorie_ids.length = 0;
        //-- Einzeleinträge aktualisieren ---
        //let rowsSelection = this.agGrid.api.getSelectedRows();
        let selectedNodes = this.agGrid.api.getSelectedNodes();
        //console.log(rowsSelection.length);
        for(let i=0; i<selectedNodes.length; i++){
          let actnode = selectedNodes[i];
          let newData = this.pbData.pbcategories.find(x => x.id === actnode.data.id);
          if(newData){
            actnode.setData(newData);
            this.agGrid.api.onFilterChanged();
          }    
        }
        this.gridOptionsKategorie.api.updateRowData(transactionobject);

        this.agGrid.api.sizeColumnsToFit();
        
      }
      
    });        
  }


  showDetail(detail){
    this.navCtrl.push(PbkategorienEditPage, {id:detail.id});
  }
  add(){
    this.navCtrl.push(PbkategorienEditPage, {id:-1});    
  }

  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass(node) {
    return true;
  }  

  filterItems(ev: any) {
    this.searchGrid(ev);

  }     
  searchGrid(event){
    this.gridOptionsKategorie.api.setQuickFilter(this.searchQuery);
  }  

  gridRowDblClicked(event: any){ 
    this.showDetail(event.data)
  }

  gridClearFilter(){

    this.agGrid.api.setFilterModel(null);
    this.agGrid.api.onFilterChanged();
  }    
  async archivieren(pbkat){
    let result:any = await this.pbData.archiveKategorie(pbkat.id);        
    if(result){
      let toast = this.toastCtrl.create({
        message: "Kategorie " + result.name + " archiviert",
        position: 'top',
        cssClass: 'toast-error',
        duration: 3000
      });
      pbkat.archiviert = 1;
      this.agGrid.api.refreshCells();
      this.agGrid.api.onFilterChanged(); 
      toast.present();   
    }
    else{
      let toast = this.toastCtrl.create({
        message: "Fehler beim Archivieren",
        position: 'top',
        cssClass: 'toast-error',
        duration: 5000
      });
      
      toast.present();   
    }
  }
  presentActions(event) {

    let rowsSelection = this.agGrid.api.getSelectedRows();

    if(rowsSelection.length <= 0){
      let toast = this.toastCtrl.create({
        message: "Es ist keine Kategorie ausgewählt",
        position: 'top',
        cssClass: 'toast-error',
        duration: 3000
      });
      
      toast.present();   
      return;        
    }

    let popover = this.popoverCtrl.create(PbKategorieactionsPage, {}, {cssClass: 'pbactions-popover'});    
    popover.onDidDismiss(async data => {
      const selectedNodes = this.agGrid.api.getSelectedNodes();
      const selectedData = selectedNodes.map( node => node.data );
      let pbkat = null;
      let result:any = null;
      if(selectedData && selectedData.length>0){
        pbkat = selectedData[0];
      }
      
      switch (this.pbData.selectedKategorieAction) {
        case PbKategorieActions.ShowDetail:
            if(pbkat){
              this.showDetail(pbkat);
            }
            break;

        case PbKategorieActions.ShowPb:
            if(pbkat){
              this.pbData.filterPbKat = pbkat.name;
              this.navCtrl.push(ParkbewilligungenListPage, {});
              //this.showDetail(pbkat);
            }
            break;

        case PbKategorieActions.CopyBestellUrl:
          if(pbkat){
            let bestellurl = await this.pbData.getKategorieBestellURL(pbkat.id)
            //this.pbData.copyTextClipboard(this.common.pbappurl+bestellurl)  
            //-- DOM-Hack funktioniert hier nicht-----
          }
            
            break;
        case PbKategorieActions.Duplicate:
          result = await this.pbData.copyKategorie(pbkat.id);     
          //console.log(result);   
          if(result){
            let toast = this.toastCtrl.create({
              message: "Kategorie " + result.name + " erstellt",
              position: 'top',
              cssClass: 'toast-error',
              duration: 3000
            });
            //pbkat.archiviert = 1;
            //this.agGrid.api.refreshCells();
            //this.agGrid.api.onFilterChanged(); 
            toast.present();   
            this.loaddata();
          }
          else{
            let toast = this.toastCtrl.create({
              message: "Fehler beim Duplizieren",
              position: 'top',
              cssClass: 'toast-error',
              duration: 5000
            });
            
            toast.present();   
          }
          break;
      case PbKategorieActions.Archive:
        let alert = this.alertCtrl.create({
          title: 'Kategorie archivieren',
          message: 'Wollen Sie diese Kategorie wirklich archivieren? Dadurch sind keine Bestellungen mehr möglich.',
          buttons: [
            {
              text: 'Nein',
              role: 'cancel',
              handler: () => {
                console.log('Cancel clicked');
              }
            },
            {
              text: 'Ja',
              handler: () => {
                this.archivieren(pbkat);


              }
            }          
          ]
        });
        alert.present();      
            break;

        default:
            break;
        }      
    }); 
    popover.present({
      ev: event
    });
  }  

  async excelExport(){
    var params = {
      allColumns: true,
      onlySelected: false,
      fileName: "kategorien.xlsx",
      sheetName: "Kategorien",
      exportMode: "xlsx"
    };    
    this.gridOptionsKategorie.api.exportDataAsExcel(params);
  }

}




// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/pbkategorien/pbkategorien.ts